module.exports = __webpack_public_path__ + "img/vouchers-white.13059cf0.svg";